import moment from "moment";
import { HOLIDAYS_2025 } from "./constants/dates/holidays";

export function generateNextTenDays() {
  let dates = [];
  for (let index = 1; index <= 10; index++) {
    dates.push(
      moment().add(index, "day").endOf("day").format("DD/MM/YYYY")
    );
  }

  return dates;
}

export function generateDays(days){
  let dates = [];
  for (let index = 1; index <= days; index++) {
    dates.push(
      moment().add(index, "day").endOf("day").format("DD/MM/YYYY")
    );
  }
  return dates;
}

export function generateTenDaysWithoutSunday() {
  let dates = [];
  let count = 0;
  let currentDate = moment().add(1, "day").startOf("day");

  while (count < 9) {
    if (currentDate.day() !== 0) {
      dates.push(currentDate.format("DD/MM/YYYY"));
      count++;
    }
    currentDate.add(1, "day");
  }

  return dates;
}

export function generateTenDaysWithoutSundayAndHolidays() {
  let dates = [];
  let count = 0;
  let currentDate = moment.utc().add(1, "day").startOf("day");
  
  while (count < 9) {
    const weekDay = currentDate.day();
    const formattedDate = currentDate.format("DD/MM/YYYY");

    const isSunday =  weekDay === 0;
    const isHoliday = HOLIDAYS_2025.includes(formattedDate);

    if (!isSunday && !isHoliday) {
      dates.push(currentDate.format("DD/MM/YYYY"));
      count++;
    }

    currentDate.add(1, "day");
  }

  return dates;
}